import { useEffect } from "react";
import { useDeviceType } from "hooks";
import { deviceTypeEnum } from "hooks/useDeviceType";
import { isDisableAds } from "components/ads/utils";

const TIMEOUT = 500;

export const ChatHead = () => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;

  useEffect(() => {
    const isLoaded = document.querySelector("script[src^='https://www.cwchmb.com']") !== null;

    if (isLoaded || !isDesktop || isDisableAds()) {
      return;
    }

    try {
      if (window.location.pathname.indexOf("/ifr/") === 0) {
        console.debug("[ads] not showing chatHead in iframes");
        return;
      }

      setTimeout(init, TIMEOUT);
    } catch (e) {
      console.debug("[ads] error loading chatHead");
    }
  }, [isDesktop]);

  return null;
};

const init = () => {
  loadScript();
  patchAddEventListener();
};

const disableIframe = () => {
  const jerkyIframe = document.querySelector("#jerky-im-cams-widget");
  if (jerkyIframe === null) {
    return;
  }

  const src = jerkyIframe.getAttribute("src");
  if (src === null) {
    return;
  }

  jerkyIframe.setAttribute("data-src", src);
  jerkyIframe.removeAttribute("src");
};

const enableIframe = () => {
  const jerkyIframe = document.querySelector("#jerky-im-cams-widget");
  if (jerkyIframe === null) {
    return;
  }

  const src = jerkyIframe.getAttribute("data-src");
  if (src === null) {
    return;
  }

  jerkyIframe.setAttribute("src", src);
  jerkyIframe.removeAttribute("data-src");
};

const addEventListeners = () => {
  const jerkyBubble = document.getElementById("jerky-im-avatar-bubble");

  const jerkyCloseBtn = document.getElementById("jerky-im-close");

  if (jerkyBubble !== null) {
    jerkyBubble.addEventListener("click", () => {
      jerkyToggleChat(true);
    });
  }

  if (jerkyCloseBtn !== null) {
    jerkyCloseBtn.addEventListener("click", () => {
      jerkyToggleChat(false);
    });
  }
};

const jerkyToggleChat = (toggle: boolean) => {
  toggle ? enableIframe() : disableIframe();
};

const loadScript = () => {
  const js = document.createElement("script");

  js.async = true;
  js.src =
    "https://www.cwchmb.com/im_jerky?" +
    "vlmi=1" +
    "&vlm=1" +
    "&vlmd=v.vfgte.com" +
    "&vlmcid=d35e5c47-8e8d-4bcf-86e8-b285e231bf95" +
    "&subID1=VGIL_999528998_REDG_CHHD_ALL" +
    "&source=TS507-999528998" +
    "&affiliateID=108124" +
    "&Location_Alias=CHHD" +
    "&livefeed={performerName}" +
    "&providers=streamate" +
    "&genders=f%2Cff" +
    "&skin=1" +
    "&canHide=1" +
    "&containerAlignment=center" +
    "&cols=4" +
    "&rows=1" +
    "&number=4" +
    "&background=transparent" +
    "&useFeed=1" +
    "&animateFeed=1" +
    "&smoothAnimation=1" +
    "&ratio=1" +
    "&verticalSpace=10px" +
    "&horizontalSpace=10px" +
    "&colorFilter=0" +
    "&colorFilterStrength=0" +
    "&AuxiliaryCSS=%0A" +
    "&token=fdecb600-9bd9-11ec-b9c9-0fb5c35adf26" +
    "&isLive=1" +
    "&sound=off";

  document.head.appendChild(js);
};

const patchAddEventListener = () => {
  if (document.readyState !== "loading") {
    const { addEventListener: oldAddEventListener } = document;

    document.addEventListener = (type: string, listener: (this: Document, ev: Event) => any, options?: boolean | AddEventListenerOptions): void => {
      if (type !== "DOMContentLoaded" || listener.name !== "injectWidget") {
        oldAddEventListener.call(document, type, listener, options);
        return;
      }

      listener.call(document, new Event("injectWidget"));
      document.addEventListener = oldAddEventListener;

      setTimeout(() => {
        addEventListeners();
        disableIframe();
      }, 0);
    };
  }
};
